import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {ClipLoader, ScaleLoader} from "react-spinners";
import Api from "../../Api/api";
import { toast } from "react-toastify";
import Modal from "../../components/modal/modal";

const CompanyInfoPopUpDGGEdit = ({ portal, company, companyName, show, toggle }) => {
    const [stepsLoading, setStepsLoading] = useState(true);
    const [info, setInfo] = useState(null);

    const {
        Firma_Kurz: firmaKurz,
        Adresse: adresse,
        PLZ: plz,
        Stadt: stadt,
        Mitarbeiter: mitarbeiter,
        Telefon: telefon,
        Webseite: webseite,
        USt_ID: uStId,
    } = info || {};

    useEffect(() => {
        if (!show) return;
        setStepsLoading(true);
        Api().get(`/customerDetailsForEdit/${portal}/${company}`)
            .then((res) => {
                setInfo(res.data[0]);
                setStepsLoading(false);
            })
            .catch(() => setStepsLoading(false));
    }, [show]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setStepsLoading(true);
        const formData = new FormData(e.target);
        const Data = Object.fromEntries(formData.entries());
        Data.portal = portal;
        Data.company = company;
        Data.companyName = companyName;

        Api()
            .post("/setCustomerDetails", Data)
            .then((res) => {
                const response = getFirstItemWithoutKey(res.data[0]);
                if (response !== null) toast.success(response);
                setStepsLoading(false);
                toggle(false);
            })
            .catch(() => {
                toast.error("irgendwas ist schief gelaufen!");
                setStepsLoading(false);
            });
    };

    const getFirstItemWithoutKey = (obj) => {
        for (const key in obj) {
            if (!key || key.trim() === "") return obj[key];
        }
        return null;
    };

    return (
        <Modal visible={show} onClose={() => toggle(false)}>
            {stepsLoading ? (
                <div className="flex justify-center items-center h-40">
                    <ClipLoader size={32} color={"#b4b4b4"}/>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-3">
                    <h2 className="text-left text-xl font-bold mb-2">
                        Firmen-Stammdaten – Firmendetails
                    </h2>
                    <p className="text-sm text-left text-grey">
                        Korrigieren oder ergänzen Sie hier die Stammdaten.<br/>
                        Nach Prüfung durch den Innendienst werden die Änderungen übernommen. Das kann einige Tage dauern.
                    </p>

                    {[
                        { label: "Firma", name: "firmaKurz", value: firmaKurz },
                        { label: "Anschrift", name: "adresse", value: adresse },
                        { label: "PLZ", name: "plz", value: plz },
                        { label: "Stadt", name: "stadt", value: stadt },
                        {
                            label: "Mitarbeiter",
                            name: "mitarbeiter",
                            value: mitarbeiter,
                            type: "number",
                        },
                        { label: "Telefon", name: "telefon", value: telefon },
                        { label: "Webseite", name: "webseite", value: webseite },
                        { label: "USt-ID", name: "uStId", value: uStId },
                    ].map(({ label, name, value, type = "text" }) => (
                        <div key={name} className="text-left">
                            <label className="block font-medium text-sm mb-1">{label}:</label>
                            <input
                                type={type}
                                name={name}
                                defaultValue={value}
                                className="w-full border rounded px-3 py-2 text-sm bg-white"
                            />
                        </div>
                    ))}

                    <div className="flex gap-4 mt-4">
                        <button
                            type="submit"
                            className="w-1/2 py-2 px-4 rounded text-white bg-mainBlue hover:bg-blue-600"
                        >
                            Änderung beantragen
                        </button>
                        <button
                            type="button"
                            onClick={() => toggle(false)}
                            className="w-1/2 py-2 px-4 rounded text-white bg-cancel hover:bg-red-600"
                        >
                            Abbrechen
                        </button>
                    </div>
                </form>
            )}
        </Modal>
    );
};

CompanyInfoPopUpDGGEdit.propTypes = {
    portal: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    companyName: PropTypes.string,
    show: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
};

export default CompanyInfoPopUpDGGEdit;
